<template>
  <div>
    <template v-for="(item, index) in newItems">
      <router-link
        v-if="$router.userHasPermission(item)"
        :key="level + '_' +  index"
        tag="div"
        :to="!item.children ? item.path : ''"
        :replace="!item.children ? replace : ''"
        :append="!item.children ? append : ''"
        :exact="!item.children ? true : ''"
        :event="!item.children ? event : ''"
        :data-cy="item.title">
        <v-list-group
          v-if="item.children && item.children.length"
          v-model="item.active"
          :key="'group' - level + '_' +  index"
          color="white"
          no-action
          :class="'v-list-group-level-' + level"
          :sub-group="subgroup"
          data-cy="menulist-group">
          <template v-if="subgroup" v-slot:prependIcon>
            <v-icon class="v-list-group-custom-rotate" :class="item.active ? 'v-list-group-custom-rotate-active' : ''" :key="'activator' + itemKey + '_' +  index">mdi mdi-menu-down</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-icon v-if="!subgroup" data-cy="menulist-group-item-icon">
              <v-icon size="18" :data-cy="`item-icon-${item.icon}`">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content data-cy="menulist-group-item-content">
              <v-list-item-title
                class="pl-2 body-2"
                data-cy="menulist-group-item-title"
              >{{item.title}}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon v-if="subgroup" data-cy="menulist-group-item-icon">
              <v-icon size="18" :data-cy="`item-icon-${item.icon}`">{{ item.icon }}</v-icon>
            </v-list-item-icon>
          </template>
          <core-menulist
            :level="level + 1"
            :itemKey="itemKey + '_' + index"
            :subgroup="true"
            :items="item.children">
          </core-menulist>
        </v-list-group>

        <v-list-item router :to="item.path"  data-cy="menulist-group" v-else>
          <v-list-item-icon v-if="item.icon" data-cy="menulist-group-item-icon">
            <v-icon size="18" :data-cy="`item-icon-${item.icon}`">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="pl-2 body-2" data-cy="menulist-group-item-title">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </router-link>
  </template>
  </div>
</template>
<script>
export default {
  props: {
    level: {
      type: Number,
      default: 1
    },
    itemKey: {
      type: String,
      default: '0'
    },
    items: Array,
    linkClass: {
      type: String,
      default: ''
    },
    badge: {
      default: null
    },
    badgeClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },

    // router props
    subgroup: {
      type: Boolean,
      default: false
    },
    replace: {
      type: Boolean,
      default: false
    },
    append: {
      type: Boolean,
      default: false
    },
    event: null,
    orientation: {
      type: String,
      default: 'vertical'
    }
  },
  data () {
    return {
      newItems: []
    }
  },
  mounted () {
    const th = this
    th.newItems = th.items.map(p => {
      th.$set(p, 'active', th.isMenuOpen(p.path))
      return p
    })
  },
  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },
    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    }
  }
}
</script>

<style>
#menulist .v-list-item__icon {
  margin-right: 2px;
}
#menulist .v-list-group--sub-group.v-list-group--active .v-list-item__icon.v-list-group__header__prepend-icon .v-icon {
    transform: rotate(0deg) ;
}
#menulist .v-list-group-custom-rotate {
    transition: transform .3s ease-in-out !important;
}

#menulist .v-list-group-custom-rotate.v-list-group-custom-rotate-active {
    transform: rotate(-180deg)  !important;
}

#menulist .v-list-group-level-1 .v-list-item{
 padding-left: 20px !important;
}

#menulist .v-list-group-level-2 .v-list-item{
 padding-left: 24px !important;
}

#menulist .v-list-group-level-3 .v-list-item{
 padding-left: 32px !important;
}

#menulist .v-list-group-level-4 .v-list-item{
 padding-left: 40px !important;
}

#menulist .v-list-group-level-5 .v-list-item{
 padding-left: 48px !important;
}

#menulist .v-list-group-level-6 .v-list-item{
 padding-left: 56px !important;
}
</style>
